module.exports = __webpack_public_path__ + "static/media/icon-defect.f96c9519.svg";